import Brand, { CatalogueCategory, FunctionnalityProduct } from './Brand';
import { IProductFunctionnality } from '../products/IProduct';

export default class EdroBrand implements Brand {
  getLogo(): any {
    return '/assets/ecosystem/images/brands/edro/light-logo.png';
  }

  getBrandKey(): string {
    return 'edro';
  }

  getBrandName(): string {
    return 'e.Dro';
  }

  getTheme(): string {
    return 'acwa';
  }

  getMainColor(): string {
    return '#f39200';
  }

  getInstallationProductsOrder(): string[] {
    return [
      'P00039',
      'P00031',
      'P00036-00',
      'P00047-00',
      'P00036-01',
      'P00046',
      'P00032',
      'P00036-07',
      'P00049',
      'P00037-00',
      'P00036-05',
      'P00048-00',
      'P00036-06',
      'P00048-01',
      'P00036-03',
      'P00047-03',
      'P00036-02',
      'P00047-02',
      'P00036-04',
      'P00047-04',
      'P00045',
      'P00042',
      'P00041',
      'P00030',
      'P00043',
      'P00061',
      'P00062',
      'P00058',
      'P00066-00',
      'P00076',
      'P00080',
    ];
  }

  getFunctionnalityProductsOrder(): FunctionnalityProduct[] {
    return [
      {
        name: 'filtrationstandard',
        modelIdentifier: 'P00036-00',
        functionnality: IProductFunctionnality.FILTRATION_STANDARD,
        picto: 'picto-filtration',
      },
      {
        name: 'filtrationstandard',
        modelIdentifier: 'P00047-00',
        functionnality: IProductFunctionnality.FILTRATION_STANDARD,
        picto: 'picto-filtration',
      },
      {
        name: 'filtrationvs',
        modelIdentifier: 'P00036-01',
        functionnality: IProductFunctionnality.FILTRATION_VS,
        picto: 'picto-filtration',
      },
      {
        name: 'filtrationvs',
        modelIdentifier: 'P00046',
        functionnality: IProductFunctionnality.FILTRATION_VS,
        picto: 'picto-filtration',
      },
      {
        name: 'filtrationvs',
        modelIdentifier: 'P00058',
        functionnality: IProductFunctionnality.FILTRATION_VS,
        picto: 'picto-ecremage',
      },
      {
        name: 'filtrationvs',
        modelIdentifier: 'P00066-00',
        functionnality: IProductFunctionnality.FILTRATION_VS,
        picto: 'picto-ecremage',
      },
      {
        name: 'electrolyseurstandard',
        modelIdentifier: 'P00036-07',
        functionnality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        picto: 'picto-electrolyseur',
      },
      {
        name: 'electrolyseurstandard',
        modelIdentifier: 'P00049',
        functionnality: IProductFunctionnality.ELECTROLYSEUR_STANDARD,
        picto: 'picto-electrolyseur',
      },
      {
        name: 'electrolyseursalt',
        modelIdentifier: 'P00037-00',
        functionnality: IProductFunctionnality.ELECTROLYSEUR_SALT,
        picto: 'picto-electrolyseur',
      },
      {
        name: 'injectioncl',
        modelIdentifier: 'P00036-05',
        functionnality: IProductFunctionnality.INJECTION_CHLORE,
        picto: 'picto-injection-cl',
      },
      {
        name: 'injectioncl',
        modelIdentifier: 'P00048-00',
        functionnality: IProductFunctionnality.INJECTION_CHLORE,
        picto: 'picto-injection-cl',
      },
      {
        name: 'injectionph',
        modelIdentifier: 'P00036-06',
        functionnality: IProductFunctionnality.INJECTION_PH,
        picto: 'picto-injection-ph',
      },
      {
        name: 'injectionph',
        modelIdentifier: 'P00048-01',
        functionnality: IProductFunctionnality.INJECTION_PH,
        picto: 'picto-injection-ph',
      },
      {
        name: 'injectionclph',
        modelIdentifier: 'P00080',
        functionnality: IProductFunctionnality.INJECTION_CLPH,
        picto: 'picto-altimeo-touch',
      },
      {
        name: 'waterlevel',
        modelIdentifier: 'P00076',
        functionnality: IProductFunctionnality.WATER_LEVEL,
        picto: 'picto-constance',
      },
      {
        name: 'volet24',
        modelIdentifier: 'P00041',
        functionnality: IProductFunctionnality.VOLET24,
        picto: 'picto-volet',
      },
      {
        name: 'volet230',
        modelIdentifier: 'P00042',
        functionnality: IProductFunctionnality.VOLET230,
        picto: 'picto-volet',
      },
      {
        name: 'robot',
        modelIdentifier: 'P00036-03',
        functionnality: IProductFunctionnality.ROBOT,
        picto: 'picto-robot',
      },
      {
        name: 'robot',
        modelIdentifier: 'P00047-03',
        functionnality: IProductFunctionnality.ROBOT,
        picto: 'picto-robot',
      },
      {
        name: 'pac',
        modelIdentifier: 'P00043',
        functionnality: IProductFunctionnality.PAC,
        picto: 'picto-pac',
      },
      {
        name: 'pac',
        modelIdentifier: 'P00061',
        functionnality: IProductFunctionnality.PAC,
        picto: 'picto-pacwp',
      },
      {
        name: 'pac',
        modelIdentifier: 'P00062',
        functionnality: IProductFunctionnality.PAC,
        picto: 'picto-pacpoly',
      },
      {
        name: 'eclairagestandard',
        modelIdentifier: 'P00039',
        functionnality: IProductFunctionnality.ECLAIRAGE,
        picto: 'picto-eclairage',
      },
      {
        name: 'eclairagetunable',
        modelIdentifier: 'P00031',
        functionnality: IProductFunctionnality.ECLAIRAGE,
        picto: 'picto-eclairage-tunable',
      },
      {
        name: 'ncc',
        modelIdentifier: 'P00036-02',
        functionnality: IProductFunctionnality.NCC,
        picto: 'picto-ncc',
      },
      {
        name: 'ncc',
        modelIdentifier: 'P00047-02',
        functionnality: IProductFunctionnality.NCC,
        picto: 'picto-ncc',
      },
      {
        name: 'blower',
        modelIdentifier: 'P00036-04',
        functionnality: IProductFunctionnality.BLOWER,
        picto: 'picto-blower',
      },
      {
        name: 'blower',
        modelIdentifier: 'P00047-04',
        functionnality: IProductFunctionnality.BLOWER,
        picto: 'picto-blower',
      },
      {
        name: 'connect',
        modelIdentifier: 'P00045',
        functionnality: IProductFunctionnality.LINK,
        picto: 'picto-connect',
      },
    ];
  }

  getCatalogues(): CatalogueCategory[] {
    return [
      { type: 'master', icon: 'picto-coffret', products: ['P00039'] },
      {
        type: 'filtration',
        icon: 'picto-filtration',
        products: [
          'P00036-00',
          'P00047-00',
          'P00036-01',
          'P00046',
          'P00058',
          'P00066-00',
        ],
      },
      { type: 'light', icon: 'picto-eclairage', products: ['P00031'] },
      {
        type: 'treatment',
        icon: 'picto-desinfection',
        products: [
          'P00036-05',
          'P00048-00',
          'P00036-07',
          'P00049',
          'P00037-00',
          'P00080',
        ],
      },
      {
        type: 'injectionph',
        icon: 'picto-desinfection',
        products: ['P00036-06', 'P00048-01'],
      },
      {
        type: 'measure',
        icon: 'picto-mesures',
        products: ['P00030', 'P00032'],
      },
      { type: 'connect', icon: 'picto-connect', products: ['P00045'] },
      {
        type: 'pac',
        icon: 'picto-pac',
        products: ['P00043', 'P00061', 'P00062'],
      },
      {
        type: 'robot',
        icon: 'picto-robot',
        products: ['P00036-03', 'P00047-03'],
      },
      { type: 'ncc', icon: 'picto-ncc', products: ['P00036-02', 'P00047-02'] },
      {
        type: 'blower',
        icon: 'picto-blower',
        products: ['P00036-04', 'P00047-04'],
      },
      {
        type: 'volet',
        icon: 'picto-couverture',
        products: ['P00041', 'P00042'],
      },
      { type: 'waterlevel', icon: 'picto-constance', products: ['P00076'] },
    ];
  }
}
